import { Injectable } from '@angular/core';
import { Loader } from './loader/oh.loader';

@Injectable()
export class CSECoreService {

    public data: any = {};
    public config: any = {};

    private loader: Loader;

    constructor() { }

    public setLoader(loader: Loader) {
        this.loader = loader;
    }

    public getLoader() {
        return this.loader;
    }

}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/cse.coreService.ts